var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"primary":""},on:{"click":function($event){return _vm.setShow(true)}}},[_vm._v(" New pipeline ")]),(_vm.show)?_c('NewPipelineForm',{on:{"close":function($event){return _vm.setShow(false)},"created":_vm.goToPipeline}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }